import React from 'react';

interface StarRatingProps {
  rating: number;
  votings: number;
}

export const StarRating: React.FC<StarRatingProps> = ({ rating, votings }) => {
  const getRatingIcon = (val: number, rating: number): string => {
    if (rating - val >= 0) return "bi-star-fill";
    if (rating - val >= -0.59) return "bi-star-half";
    return "bi-star";
  };

  return (
    <>
      {[1, 2, 3, 4, 5].map((val) => (
        <i
          key={val}
          className={getRatingIcon(val, rating)}
          style={{ paddingRight: 8 }}
        />
      ))}{" "}
      ({votings})
    </>
  );
};